import { route } from '@/ziggy-shim';
import { api, CastValue } from './LaravelClient';

export default {
  async index(companyId: Id) {
    return await api(route('api.v1.companies.project-groups.index', companyId), 'get');
  },

  async create(companyId: Id, data: ApiRequests['api.v1.companies.project-groups.store']) {
    return await api(route('api.v1.companies.project-groups.store', companyId), 'post', {
      data,
    });
  },

  async show(id: Id) {
    return await api(route('api.v1.project-groups.show', id), 'get');
  },

  async update(id: Id, data: ApiRequests['api.v1.project-groups.update']) {
    console.log(data);

    return await api(route('api.v1.project-groups.update', id), 'patch', {
      data,
    });
  },

  async delete(id: Id) {
    return await api(route('api.v1.project-groups.destroy', id), 'delete');
  },

  async report(id: Id, data: ApiRequests['api.v1.project-groups.report']) {
    return await api(route('api.v1.project-groups.report', id), 'post', {
      data,
      casts: {
        month: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },
};
